import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";

interface CustomerState {
  isAnonymousUser: boolean;
  id: string;
  userId: string;
  displayName: string;
  phoneNumber: string;
  email: string;
  photoUrl?: string | null;
  createdAt: {
    _seconds: number;
    _nanoseconds: number;
  };
  updatedAt: {
    _seconds: number;
    _nanoseconds: number;
  };
  settings: {
    requiresOrderVerification: boolean;
  };
  addresses: {
    tag: string;
    address: string;
  }[];
}

export const uploadProfileImageHttps = createAsyncThunk(
  "customer/uploadProfileImageHttps",
  async (data: any, { rejectWithValue }) => {
    try {
      const headers = new Headers({
        "x-goog-acl": "public-read",
        "Content-Type": `image/${data.extention}`,
      });
      fetch(data.url, {
        method: "PUT",
        headers: headers,
        body: data.body,
      });
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

const initialState: CustomerState = {
  isAnonymousUser: true,
  id: "",
  userId: "",
  displayName: "",
  phoneNumber: "",
  email: "",
  photoUrl: null,
  createdAt: {
    _seconds: 0,
    _nanoseconds: 0,
  },
  updatedAt: {
    _seconds: 0,
    _nanoseconds: 0,
  },
  settings: {
    requiresOrderVerification: false,
  },
  addresses: [],
};

export const customerSlice = createSlice({
  name: "customer",
  initialState,
  reducers: {
    setCustomer: (
      state: any,
      action: PayloadAction<Partial<CustomerState>>
    ) => {
      return state
        ? { ...state, ...action.payload }
        : (action.payload as CustomerState);
    },
    clearCustomer: (state) => {
      return initialState;
    },
  },
});

export const { setCustomer, clearCustomer } = customerSlice.actions;
export default customerSlice.reducer;
